import type {
  MenuProps as ChakraMenuProps,
  ThemingProps,
} from '@chakra-ui/react';
import { Menu as ChakraMenu } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';

export type MenuProps = OmitChakraProps<ChakraMenuProps, keyof ThemingProps>;

export const Menu = (props: MenuProps) => {
  return <ChakraMenu {...props} />;
};
